import QueryString from "qs"
import {
  apiGetAllTopicGuest,
  apiGetByRegionId,
  apiGetAllCourse,
  apiGetAllTeacher,
  apiGetAllTopicByCourse,
  apiGetDetailCourse,
  apiGetListBannerFooterEvent,
  apiGetListEvent,
  apiGetAllCourseHome,
  apiGetTeacherHome,
  apiGetPostHome,
  apiGetPostList,
  apiGetPostDetail,
  apiUpdateLessonLearned,
  apiGetCategoryPost,
  apiGetDetailByG,
  apiGetListStaticNavbar,
  apiGetListPostByCategoryPostID,
  apiGetListPostRelate,
  apiGetAllListPost,
} from "./urls"
import http from "../index"
const getAllTopic = () => http.post(apiGetAllTopicGuest)
const getDetail = body => {
  const params = QueryString.stringify(body)
  return http.get(`${apiGetDetailByG}?${params}`)
}
const getByRegionId = params => http.get(apiGetByRegionId, { params })
const getAllCourse = body => http.post(apiGetAllCourse, body)
const getAllTeacher = body => http.post(apiGetAllTeacher, body)
const getAllCourseHome = body => http.post(apiGetAllCourseHome, body)
const getDetailCourse = body => http.post(apiGetDetailCourse, body)
const getListBanner = () => http.get(apiGetListBannerFooterEvent)
const getListEvent = () => http.get(apiGetListEvent)
const getTeacherHome = () => http.get(apiGetTeacherHome)
const GetPostHome = () => http.get(apiGetPostHome)
const GetPostList = body => http.post(apiGetPostList, body)
const GetPostDetail = params => http.get(apiGetPostDetail, { params })
const getAllTopicByCourse = body =>
  http.patch(apiGetAllTopicByCourse + `?${QueryString.stringify(body)}`)
const updateLessonLearned = body =>
  http.patch(apiUpdateLessonLearned + `?${QueryString.stringify(body)}`)
const getCategoryPost = () => http.get(apiGetCategoryPost)
const getStaticNav = params =>
  http.get(`${apiGetListStaticNavbar}?${QueryString.stringify(params)}`)
const getListPost = body => http.post(apiGetListPostByCategoryPostID, body)
const getListPostRelate = params => http.get(apiGetListPostRelate, { params })
const getAllListPost = body => http.post(apiGetAllListPost, body)
const GuestServices = {
  getAllTeacher,
  getAllTopic,
  getByRegionId,
  getAllCourse,
  getAllCourseHome,
  getAllTopicByCourse,
  getDetailCourse,
  getListBanner,
  getListEvent,
  getTeacherHome,
  GetPostHome,
  GetPostList,
  GetPostDetail,
  updateLessonLearned,
  getCategoryPost,
  getDetail,
  getStaticNav,
  getListPost,
  getListPostRelate,
  getAllListPost,
}
export default GuestServices
